var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M510.251681 216.20311c-140.642181 0-254.656911 114.013707-254.656911 254.654864 0 88.484264 45.137013 166.417217 113.63406 212.05872l0 172.743296 283.856953 0 0-173.951821c67.479881-45.803185 111.818715-123.144668 111.818715-210.849172C764.904499 330.216817 650.891815 216.20311 510.251681 216.20311zM644.995525 608.138594c-15.053857 14.779611-32.537044 27.085892-51.801806 36.264948l0 142.501528L429.118849 786.90507 429.118849 644.505873c-19.352767-9.188266-36.912701-21.531386-52.024887-36.367279-35.354206-34.70236-57.292867-83.023902-57.292867-136.477324 0-105.620549 85.6231-191.243649 191.245695-191.243649 105.619526 0 191.241602 85.622076 191.241602 191.243649C702.288392 525.115716 680.348708 573.436234 644.995525 608.138594z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M383.660518 895.14426l256.082376 0 0 64.310701-256.082376 0 0-64.310701Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527083 690.817466l70.845699-70.845699 45.473373 45.473373-70.845699 70.845699-45.473373-45.473373Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.675356 384.027373l100.19191 0 0 64.310701-100.19191 0 0-64.310701Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M237.572121 128.297685l70.845699 70.845699-45.474097 45.474097-70.845699-70.845699 45.474097-45.474097Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M480.059032 63.715137l64.310701 0 0 100.19191-64.310701 0 0-100.19191Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M833.361813 172.754197l-70.845699 70.845699-45.474821-45.474821 70.845699-70.845699 45.474821 45.474821Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M795.189246 383.51879l100.192933 0 0 64.311725-100.192933 0 0-64.311725Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M818.908129 735.802474l-70.846423-70.846423 45.474097-45.474097 70.846423 70.846423-45.474097 45.474097Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplain);
export default __webpack_public_path__ + "static/media/explain.93ec5326558805c5f37ba772fe18b115.svg";
export { ForwardRef as ReactComponent };